import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ActivityTabNavigationParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { getIntl } from '../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import { ProfileMessageInput, useProfileMessagingState } from '../../../../shared/ProfileMessaging';

const intl = getIntl('screens.mainApp.activity.addMessage', {
    message: 'Message',
    send: 'Send',
    cancel: 'Cancel',
});

export type AuditLogDetailsScreenOwnProps = {};

export type AuditLogDetailsScreenProps = AuditLogDetailsScreenOwnProps & {
    route: RouteProp<ActivityTabNavigationParamList, 'add-message'>;
};

const AddMessageScreen: React.FC<AuditLogDetailsScreenProps> = ({
    route: {
        params: { profileIds },
    },
}) => {
    const goBack = useGoBack();
    const { onSend, isSendDisabled, message, setMessage, onCancel } = useProfileMessagingState({
        onCancel: goBack,
        onClose: goBack,
        selectedProfileIds: profileIds,
    });
    return (
        <ActionButtonLayout
            whiteBackground
            actions={[
                {
                    title: intl('cancel'),
                    icon: 'X',
                    onPress: onCancel,
                    variant: 'secondary',
                    testID: 'cancel-add-message',
                },
                {
                    title: intl('send'),
                    icon: 'Send',
                    onPress: onSend,
                    isDisabled: isSendDisabled,
                    testID: 'submit-add-message',
                },
            ]}
        >
            <MainContentContainer flex={1} testID="add-message-screen-root">
                <ProfileMessageInput
                    selectedProfileIds={profileIds}
                    message={message}
                    setMessage={setMessage}
                    type="profiles"
                />
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(AddMessageScreen);
